import {
  PaginationRequest,
  PaginationResponse,
} from '@aibees/shared/definition';
import { useBaseQuery } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';
import { UseQueryOptions } from '@tanstack/react-query';
import { COMPANY_SEARCH_API_PREFIX } from '../constants';
import { CompanySearchItem, GetCompaniesParam } from '../types';

export function useBrowseCompaniesApi<T = CompanySearchItem>(
  params: PaginationRequest<GetCompaniesParam>,
  options?: UseQueryOptions<
    PaginationResponse<CompanySearchItem>,
    any,
    PaginationResponse<T>
  >
) {
  const { page = 0, ...other } = params;

  const workspace = useWorkspace()?.id;

  return useBaseQuery<
    typeof params,
    PaginationResponse<CompanySearchItem>,
    PaginationResponse<T>
  >(
    [useBrowseCompaniesApi.name, page, other],
    {
      url: COMPANY_SEARCH_API_PREFIX.replace(':wid', String(workspace)),
      params,
      headers: { 'x-customer-id': workspace },
    },
    {
      ...options,
      select: options?.select as (
        data: PaginationResponse<CompanySearchItem>
      ) => PaginationResponse<T>,
    }
  );
}
